import React, { createContext, useState, useContext } from 'react';

const ParentCustomerContext = createContext();

export const ParentCustomerProvider = ({ children }) => {
  const [parentCustomer, setParentCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);

  return (
    <ParentCustomerContext.Provider value={{ parentCustomer, setParentCustomer, customers, setCustomers }}>
      {children}
    </ParentCustomerContext.Provider>
  );
};

export const useParentCustomer = () => useContext(ParentCustomerContext);
